import { ILetterTemplate } from "./LettersModel";

export const sortTemplates = (templates: ILetterTemplate[]) => {
    return templates.sort((a, b) => {
        if (a.isPreferred && !b.isPreferred) return -1;
        if (!a.isPreferred && b.isPreferred) return 1;

        return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
    });
};